query Roles {
    roles {
        _id
        name
        actions
    }
}
